// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__table-parent-record__KnDtr {
  background-color: #fafafa;
}
.index-module__table-container__LcObp {
  display: flex;
  flex-direction: column;
}
.index-module__role-dropdown__GUN3m {
  width: 200px;
}
.index-module__form-itemFloatR0__uzjTw {
  float: right;
  margin-top: 0px;
}
.index-module__table-parent-record__KnDtr {
  background-color: #cbc7c9;
  font-weight: 600;
}
.index-module__table-child-record__YPz5F {
  background-color: #ffcc06;
  color: black;
  font-weight: 600;
}
@media (min-width: 769px) {
  .index-module__table-container__LcObp {
    flex-direction: row;
    justify-content: space-between;
  }
  .index-module__table-container__LcObp .index-module__table__rf38G {
    width: 48%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MasterManagement/ModalComponents/AccessControlMaster/index.module.less"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;IACnB,8BAA8B;EAChC;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".table-parent-record {\n  background-color: #fafafa;\n}\n.table-container {\n  display: flex;\n  flex-direction: column;\n}\n.role-dropdown {\n  width: 200px;\n}\n.form-itemFloatR0 {\n  float: right;\n  margin-top: 0px;\n}\n.table-parent-record {\n  background-color: #cbc7c9;\n  font-weight: 600;\n}\n.table-child-record {\n  background-color: #ffcc06;\n  color: black;\n  font-weight: 600;\n}\n@media (min-width: 769px) {\n  .table-container {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n  .table-container .table {\n    width: 48%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table-parent-record": `index-module__table-parent-record__KnDtr`,
	"table-container": `index-module__table-container__LcObp`,
	"role-dropdown": `index-module__role-dropdown__GUN3m`,
	"form-itemFloatR0": `index-module__form-itemFloatR0__uzjTw`,
	"table-child-record": `index-module__table-child-record__YPz5F`,
	"table": `index-module__table__rf38G`
};
export default ___CSS_LOADER_EXPORT___;
